<template>
  <div class="spinner-container" :class="{ overlay: isOverlay }">
    <div 
      class="spinner" 
      :style="{ 
        width: `${size}px`, 
        height: `${size}px`,
        borderColor: `${color} transparent transparent transparent` 
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: '#3B82F6' // Default is blue-500 from Tailwind
    },
    isOverlay: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-container.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 10;
}

.spinner {
  border: 4px solid;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
